import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "HEV Foundations & Vehicle Electrification Basics",
    description:
      "Introduction to Hybrid Electric Vehicles & how they work, Types of hybrids: Mild Hybrid Full Hybrid Plug-In Hybrid (PHEV), Electric vs hybrid vs fully electric vehicles, Role of HEVs in modern mobility & environmental impact, Future trends in EV & hybrid technology",
  },
  {
    title: "Automotive Powertrain & Energy Flow Understanding",
    description:
      "Components of a hybrid powertrain, Engine electric motor & generator working, Torque distribution & power split concepts, Parallel series & series-parallel hybrid systems, Regenerative braking & energy recovery",
  },
  {
    title: "Battery Technology, BMS & Energy Storage Systems",
    description:
      "Lithium-ion battery chemistry & cell structure, Battery packs modules & configuration, Battery Management System (BMS) working, Charging discharging thermal management, Battery safety & lifetime optimization",
  },
  {
    title: "Electric Motors, Controllers & Power Electronics",
    description:
      "Types of motors: BLDC PMSM induction motors, Inverters converters & motor controllers, Power electronics fundamentals, Speed control & torque control logic, Motor efficiency & design considerations",
  },
  {
    title: "Hybrid Vehicle Control Systems & ECUs",
    description:
      "Electronic Control Unit (ECU) role in HEVs, Control algorithms for engine–motor coordination, Real-time energy management strategies, Sensors & actuators in HEV control, Vehicle diagnostics & onboard monitoring",
  },
  {
    title: "Transmission Systems & Drivetrain Integration",
    description:
      "Automatic, CVT & e-CVT transmissions, Gear ratios & power delivery, Integration of electric motor with transmission, Hybrid drivetrain layouts for different vehicle types, Efficiency strategies for different driving conditions",
  },
  {
    title: "Charging Systems, Regeneration & Energy Optimization",
    description:
      "Slow/fast charging systems, Regenerative braking: principles & design, Hybrid charging cycles & power flow, Improving fuel economy & energy efficiency, Real-time power optimization methods",
  },
  {
    title: "Vehicle Dynamics, Safety Systems & Thermal Management",
    description:
      "Weight distribution & handling in hybrids, Traction control ABS ESC integration, Cooling systems for battery motor & power electronics, Thermal runaway prevention, Crash safety standards for hybrid vehicles",
  },
  {
    title: "HEV Simulation, Modeling & Diagnostic Tools",
    description:
      "MATLAB/Simulink modeling for HEV design, Simulation of powertrain battery & motor systems, OBD-II diagnostics & error code analysis, Virtual testing of hybrid vehicle performance, Using industry tools for HEV development",
  },
  {
    title: "Capstone HEV Project & Career Launchpad",
    description:
      "Design a complete hybrid vehicle model, Powertrain simulation → component selection → performance testing, Technical documentation & presentation, Building an automotive engineering portfolio, Interview prep for roles in EV/HEV engineering, powertrain design & automotive R&D",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
